var Separator;
(function (Separator) {
    Separator["AND"] = ",";
    Separator["RANGE"] = "-";
    Separator["INCREMENT"] = "/";
    Separator["NTH_WEEKDAY_OF_MONTH"] = "#";
})(Separator || (Separator = {}));

var Mode;
(function (Mode) {
    Mode["AND"] = "AND";
    Mode["RANGE"] = "RANGE";
    Mode["INCREMENT"] = "INCREMENT";
    Mode["NTH_WEEKDAY_OF_MONTH"] = "NTH_WEEKDAY_OF_MONTH";
    Mode["EVERY"] = "EVERY";
    Mode["LAST_DAY"] = "LAST_DAY";
    Mode["LAST_DAY_WEEK"] = "LAST_DAY_WEEK";
    Mode["LAST_NTH_DAY_WEEK"] = "LAST_NTH_DAY_WEEK";
    Mode["DAYS_BEFORE_END_MONTH"] = "DAYS_BEFORE_END_MONTH";
    Mode["NEAREST_WEEKDAY_OF_MONTH"] = "NEAREST_WEEKDAY_OF_MONTH";
    Mode["NONE"] = "NONE";
})(Mode || (Mode = {}));
var separatorsMap = new Map([
    [Mode.AND, Separator.AND],
    [Mode.RANGE, Separator.RANGE],
    [Mode.INCREMENT, Separator.INCREMENT],
    [Mode.NTH_WEEKDAY_OF_MONTH, Separator.NTH_WEEKDAY_OF_MONTH]
]);
var ModeUtils = /** @class */ (function () {
    function ModeUtils() {
    }
    ModeUtils.getSeparator = function (mode) {
        return separatorsMap.get(mode);
    };
    ModeUtils.containsSeparator = function (mode) {
        return separatorsMap.has(mode);
    };
    ModeUtils.detect = function (str) {
        if (str.includes('L-')) {
            return Mode.DAYS_BEFORE_END_MONTH;
        }
        if (str.includes(Separator.AND)) {
            return Mode.AND;
        }
        if (str.includes(Separator.RANGE)) {
            return Mode.RANGE;
        }
        if (str === 'L') {
            return Mode.LAST_DAY;
        }
        if (str === 'LW') {
            return Mode.LAST_DAY_WEEK;
        }
        if (str.includes('L')) {
            return Mode.LAST_NTH_DAY_WEEK;
        }
        if (str.includes('W')) {
            return Mode.NEAREST_WEEKDAY_OF_MONTH;
        }
        if (str.includes(Separator.INCREMENT)) {
            return Mode.INCREMENT;
        }
        if (str.includes(Separator.NTH_WEEKDAY_OF_MONTH)) {
            return Mode.NTH_WEEKDAY_OF_MONTH;
        }
        if (str.includes('*')) {
            return Mode.EVERY;
        }
        if (str === '?') {
            return Mode.NONE;
        }
        return Mode.AND;
    };
    ModeUtils.parseToValues = function (str, mode) {
        var defaultValue = [str];
        if (Mode.DAYS_BEFORE_END_MONTH === mode) {
            return defaultValue;
        }
        if (Mode.INCREMENT === mode) {
            return str.split(Separator.INCREMENT);
        }
        if (Mode.AND === mode) {
            return str.split(Separator.AND);
        }
        if (Mode.RANGE === mode) {
            return str.split(Separator.RANGE);
        }
        if (Mode.LAST_DAY === mode) {
            return defaultValue;
        }
        if (Mode.LAST_DAY_WEEK === mode) {
            return defaultValue;
        }
        if (Mode.LAST_NTH_DAY_WEEK === mode) {
            return defaultValue;
        }
        if (Mode.NEAREST_WEEKDAY_OF_MONTH === mode) {
            return defaultValue;
        }
        if (Mode.NTH_WEEKDAY_OF_MONTH === mode) {
            return str.split(Separator.NTH_WEEKDAY_OF_MONTH);
        }
        return defaultValue;
    };
    return ModeUtils;
}());

var ValueModel = /** @class */ (function () {
    function ValueModel(d) {
        this.values = ['*'];
        this.mode = Mode.EVERY;
        if (!d) {
            return;
        }
        this.values = d.values || ['*'];
        this.mode = d.mode;
    }
    return ValueModel;
}());

var DataModel = /** @class */ (function () {
    function DataModel(d) {
        this.seconds = new ValueModel();
        this.minutes = new ValueModel();
        this.hours = new ValueModel();
        this.dayOfMonth = new ValueModel();
        this.month = new ValueModel();
        this.dayOfWeek = new ValueModel();
        this.year = new ValueModel({
            values: ['*'],
            mode: Mode.EVERY
        });
        if (!d) {
            return;
        }
        this.seconds = new ValueModel(d.seconds);
        this.minutes = new ValueModel(d.minutes);
        this.hours = new ValueModel(d.hours);
        this.dayOfMonth = new ValueModel(d.dayOfMonth);
        this.month = new ValueModel(d.month);
        this.dayOfWeek = new ValueModel(d.dayOfWeek);
        this.year = new ValueModel(d.year);
    }
    return DataModel;
}());

var Segment;
(function (Segment) {
    Segment["seconds"] = "seconds";
    Segment["minutes"] = "minutes";
    Segment["hours"] = "hours";
    Segment["dayOfMonth"] = "dayOfMonth";
    Segment["month"] = "month";
    Segment["dayOfWeek"] = "dayOfWeek";
    Segment["year"] = "year";
})(Segment || (Segment = {}));

var Type;
(function (Type) {
    Type["SECONDS"] = "SECONDS";
    Type["MINUTES"] = "MINUTES";
    Type["HOURS"] = "HOURS";
    Type["DAY"] = "DAY";
    Type["MONTH"] = "MONTH";
    Type["YEAR"] = "YEAR";
})(Type || (Type = {}));

var WeekDay;
(function (WeekDay) {
    WeekDay["Sunday"] = "Sunday";
    WeekDay["Monday"] = "Monday";
    WeekDay["Tuesday"] = "Tuesday";
    WeekDay["Wednesday"] = "Wednesday";
    WeekDay["Thursday"] = "Thursday";
    WeekDay["Friday"] = "Friday";
    WeekDay["Saturday"] = "Saturday";
})(WeekDay || (WeekDay = {}));
var WeekDayCode;
(function (WeekDayCode) {
    WeekDayCode["SUN"] = "SUN";
    WeekDayCode["MON"] = "MON";
    WeekDayCode["TUE"] = "TUE";
    WeekDayCode["WED"] = "WED";
    WeekDayCode["THU"] = "THU";
    WeekDayCode["FRI"] = "FRI";
    WeekDayCode["SAT"] = "SAT";
})(WeekDayCode || (WeekDayCode = {}));
var codeMap = new Map([
    [WeekDay.Sunday, WeekDayCode.SUN],
    [WeekDay.Monday, WeekDayCode.MON],
    [WeekDay.Tuesday, WeekDayCode.TUE],
    [WeekDay.Wednesday, WeekDayCode.WED],
    [WeekDay.Thursday, WeekDayCode.THU],
    [WeekDay.Friday, WeekDayCode.FRI],
    [WeekDay.Saturday, WeekDayCode.SAT]
]);
var WeekDayUtils = /** @class */ (function () {
    function WeekDayUtils() {
    }
    WeekDayUtils.list = function () {
        return [
            WeekDay.Sunday,
            WeekDay.Monday,
            WeekDay.Tuesday,
            WeekDay.Wednesday,
            WeekDay.Thursday,
            WeekDay.Friday,
            WeekDay.Saturday
        ];
    };
    WeekDayUtils.getCode = function (weekDay) {
        return codeMap.get(weekDay);
    };
    return WeekDayUtils;
}());

var Month;
(function (Month) {
    Month["January"] = "January";
    Month["February"] = "February";
    Month["March"] = "March";
    Month["April"] = "April";
    Month["May"] = "May";
    Month["June"] = "June";
    Month["July"] = "July";
    Month["August"] = "August";
    Month["September"] = "September";
    Month["October"] = "October";
    Month["November"] = "November";
    Month["December"] = "December";
})(Month || (Month = {}));
var MonthCode;
(function (MonthCode) {
    MonthCode["JAN"] = "JAN";
    MonthCode["FEB"] = "FEB";
    MonthCode["MAR"] = "MAR";
    MonthCode["APR"] = "APR";
    MonthCode["MAY"] = "MAY";
    MonthCode["JUN"] = "JUN";
    MonthCode["JUL"] = "JUL";
    MonthCode["AUG"] = "AUG";
    MonthCode["SEP"] = "SEP";
    MonthCode["OCT"] = "OCT";
    MonthCode["NOV"] = "NOV";
    MonthCode["DEC"] = "DEC";
})(MonthCode || (MonthCode = {}));
var codeMap$1 = new Map([
    [Month.January, MonthCode.JAN],
    [Month.February, MonthCode.FEB],
    [Month.March, MonthCode.MAR],
    [Month.April, MonthCode.APR],
    [Month.May, MonthCode.MAY],
    [Month.June, MonthCode.JUN],
    [Month.July, MonthCode.JUL],
    [Month.August, MonthCode.AUG],
    [Month.September, MonthCode.SEP],
    [Month.October, MonthCode.OCT],
    [Month.November, MonthCode.NOV],
    [Month.December, MonthCode.DEC]
]);
var MonthUtils = /** @class */ (function () {
    function MonthUtils() {
    }
    MonthUtils.everyList = function () {
        return [
            '1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th',
            '11th', '12th', '13th', '14th', '15th', '16th', '17th', '18th', '19th',
            '20th', '21st', '22nd', '23rd', '24th', '25th', '26th', '27th', '28th',
            '29th', '30th', '31st'
        ];
    };
    MonthUtils.list = function () {
        return [
            Month.January,
            Month.February,
            Month.March,
            Month.April,
            Month.May,
            Month.June,
            Month.July,
            Month.August,
            Month.September,
            Month.October,
            Month.November,
            Month.December
        ];
    };
    MonthUtils.getCode = function (weekDay) {
        return codeMap$1.get(weekDay);
    };
    return MonthUtils;
}());

var CoreService = /** @class */ (function () {
    function CoreService() {
        this.seconds = this.genList(0, 59);
        this.secondsEvery = this.genList(1, 60);
        this.minutes = this.genList(0, 59);
        this.minutesEvery = this.genList(1, 60);
        this.hours = this.genList(0, 23);
        this.hoursEvery = this.genList(1, 24);
        this.year = this.genList(2019, 2098);
        this.yearEvery = this.genList(1, 93);
        this.dayOfMonth = this.genList(1, 31);
        this.dayOfMonthEvery = this.createOptions(MonthUtils.everyList());
        this.dayOfWeek = this.createOptions(WeekDayUtils.list());
        this.dayOfWeekEvery = this.genList(1, 7);
        this.month = this.createOptions(MonthUtils.list());
        this.monthEvery = this.genList(1, 12);
    }
    CoreService.prototype.getDaysOfWeekCodes = function () {
        return WeekDayUtils
            .list()
            .map(function (v) {
            return {
                value: WeekDayUtils.getCode(v),
                label: v
            };
        });
    };
    CoreService.prototype.getMonthCodes = function () {
        return MonthUtils
            .list()
            .map(function (v) {
            return {
                value: MonthUtils.getCode(v),
                label: v
            };
        });
    };
    CoreService.prototype.getList = function (segment, every) {
        if (every === void 0) { every = false; }
        if (segment === Segment.seconds) {
            return every ? this.secondsEvery : this.seconds;
        }
        if (segment === Segment.minutes) {
            return every ? this.minutesEvery : this.minutes;
        }
        if (segment === Segment.hours) {
            return every ? this.hoursEvery : this.hours;
        }
        if (segment === Segment.dayOfMonth) {
            return every ? this.dayOfMonthEvery : this.dayOfMonth;
        }
        if (segment === Segment.year) {
            return every ? this.yearEvery : this.year;
        }
        if (segment === Segment.month) {
            return every ? this.monthEvery : this.month;
        }
        if (segment === Segment.dayOfWeek) {
            return every ? this.dayOfWeekEvery : this.dayOfWeek;
        }
        return [];
    };
    CoreService.prototype.toModel = function (expression) {
        var _this = this;
        var model = new DataModel();
        if (!expression) {
            model.dayOfMonth.values = ['?'];
            model.hours.mode = Mode.AND;
            model.hours.values = ['0'];
            model.minutes.mode = Mode.AND;
            model.minutes.values = ['0'];
            model.seconds.mode = Mode.AND;
            model.seconds.values = ['0'];
            return model;
        }
        var keys = Object.keys(model);
        expression.split(' ')
            .forEach(function (s, i) {
            var key = keys[i];
            var v = _this.parseSegment(s);
            model[key] = v;
        });
        return model;
    };
    CoreService.prototype.toString = function (model) {
        var values = [
            this.stringifySegment(model.seconds),
            this.stringifySegment(model.minutes),
            this.stringifySegment(model.hours),
            this.stringifySegment(model.dayOfMonth),
            this.stringifySegment(model.month),
            this.stringifySegment(model.dayOfWeek),
            this.stringifySegment(model.year)
        ];
        return values.join(' ');
    };
    CoreService.prototype.stringifySegment = function (v) {
        var mode = v.mode;
        if (ModeUtils.containsSeparator(mode)) {
            return v.values.join(ModeUtils.getSeparator(mode));
        }
        return v.values.join('');
    };
    CoreService.prototype.parseSegment = function (segment) {
        var mode = ModeUtils.detect(segment);
        return new ValueModel({
            mode: mode,
            values: ModeUtils.parseToValues(segment, mode)
        });
    };
    CoreService.prototype.createOptions = function (labels) {
        return labels.map(function (v, i) {
            return {
                label: v,
                value: (i + 1).toString()
            };
        });
    };
    CoreService.prototype.genList = function (from, to) {
        var list = [];
        for (var x = from; x <= to; x++) {
            list.push({ value: "" + x, label: "" + x });
        }
        return list;
    };
    return CoreService;
}());

export { CoreService, DataModel, Mode, ModeUtils, Month, MonthCode, MonthUtils, Segment, Separator, Type, ValueModel, WeekDay, WeekDayCode, WeekDayUtils };
//# sourceMappingURL=sbzen-cron-core.js.map
